import { createReducer } from "./helper";

export const WINDOW_SIZE = "ui/window_size";
export const HEADER_SEARCH_FOCUS_CHANGE = "ui/header-search-focus-change";

export const reducer = createReducer(
    {
        headerSearchHasFocus: false,
        viewport: { width: 0, height: 0 },
    },
    {
        [HEADER_SEARCH_FOCUS_CHANGE]: (state, action) => ({
            ...state,
            headerSearchHasFocus: action.hasFocus,
        }),

        [WINDOW_SIZE]: (state, { width, height }) => ({
            ...state,
            viewport: { width, height },
        }),
    }
);

export const toggleHeaderSearch = hasFocus => ({
    type: HEADER_SEARCH_FOCUS_CHANGE,
    hasFocus,
});

export const setViewport = ({ width, height }) => ({
    type: WINDOW_SIZE,
    width,
    height,
});
